import React from 'react';
import { GamedayLiveDesktopWrapper, ChipFeedWrapper, PlayerDuelScoresWrapper } from '../fieldvision.style';
import TeamSummaryMatchUpDataContainer from '../../TeamSummaryMatchup/TeamSummaryMatchupDataContainer';
import FieldVisionPlayerDuelDataContainer from '../../PlayerDuel/containers/FieldVisionPlayerDuelDataContainer';
import ChipFeedDataContainer from '../../ChipFeed/containers/ChipFeedDataContainer';
const trackingConfig = ['FieldVision', 'TeamSummaryMatchup'];
const GamedayLiveDesktop = () => {
    return (
        <>
            <GamedayLiveDesktopWrapper>
                <PlayerDuelScoresWrapper>
                    <TeamSummaryMatchUpDataContainer
                        mobileWidth={false}
                        hideTeamNames={false}
                        displayRecords={true}
                        useTri={true}
                        componentName={trackingConfig}
                    />
                    <FieldVisionPlayerDuelDataContainer stacked showUpcomingBatters={ false } />
                </PlayerDuelScoresWrapper>
                <ChipFeedWrapper><ChipFeedDataContainer /></ChipFeedWrapper>
            </GamedayLiveDesktopWrapper>
        </>
    );
};

export default GamedayLiveDesktop;
